export interface GetOrderSelectionRequest {
  id: number
  marcNo: string
}

export function GetOrderSelectionRequestToJSON(
  value: GetOrderSelectionRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    marc_no: value.marcNo !== '' ? value.marcNo : undefined
  }
}
